import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { HelpCircle as HelpCircleIcon, Plus as PlusIcon } from 'react-feather'
import { Button, Hidden, Paper, TablePagination } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  FilterButton,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'
import { AssetInventoryFilter, AssetInventoryTable } from './components'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'
import usePermissions from 'hooks/usePermissions'
import useAssetInventory from 'hooks/useAssetInventory'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'

const AssetInventoryMain = () => {
  const { MAIN_STEP_1, MAIN_STEP_2, MAIN_STEP_3, MAIN_STEPS_OBJECT } =
    constants.tours.assetInventory

  const [loading, setLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)

  const filter = useFilter()
  const history = useHistory()
  const { permitted } = usePermissions()
  const { assetInventoryCategories, loadingCategories } = useAssetInventory()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.assetInventory.get,
    { minimal: true, perPage, page, ...filter.filters },
    [perPage, page, filter.filters],
  )

  const assetInventories = response?.data?.assetInventories || []

  const filteredSteps = MAIN_STEPS_OBJECT.filter((step) => {
    if (step.element === '#' + MAIN_STEP_2) {
      return permitted(constants.permissions.ASSET_INVENTORY.MANAGE)
    }
    return true
  })

  const handleRedirect = () => history.push(routes.assetInventory.new)

  const handleOpenTour = () => setOpenTour((prev) => !prev)

  return (
    <Page title="Inventário de ativos">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading || loading} />
        <ContentHeader title="Inventário de ativos">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={MAIN_STEP_1}
            fullWidth
          >
            Tutorial
          </Button>
          <Permitted tag={constants.permissions.ASSET_INVENTORY.MANAGE}>
            <Button
              variant="contained"
              color="primary"
              id={MAIN_STEP_2}
              startIcon={<PlusIcon />}
              onClick={handleRedirect}
            >
              Novo Inventário
            </Button>
          </Permitted>
          <FilterButton
            setDrawerOpen={filter.setDrawerOpen}
            isLoading={loadingCategories}
          />
        </ContentHeader>
        <Paper variant="outlined">
          <AssetInventoryTable
            id={MAIN_STEP_3}
            isLoading={isLoading}
            setLoading={setLoading}
            refresh={refresh}
            assetInventories={assetInventories}
          />
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Paper>
      </Container>
      <DriveTour
        stepsMatrix={filteredSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
      {!loadingCategories && (
        <AssetInventoryFilter
          filter={filter}
          assetInventoryCategories={assetInventoryCategories}
        />
      )}
    </Page>
  )
}

export default AssetInventoryMain
